var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hui-helper-container"},[_c('TrapezoidBgImg',{nativeOn:{"click":function($event){return _vm.handleHuiHelperClick.apply(null, arguments)}}},[_vm._v("慧助手")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }